<script setup>
// X183 (Grant 2026-10-27, on the goals question: "a bit too much red on red on red"). The ONE status label of the goals
// question, shared by the home dialog's tiles and the assistant's tickbox card so both read the same and every label is
// the same size (memory: consistent chip sizes): "Always included" and "Not picked" are quiet grey, "Already set up" is
// success-tinted; never brand red (red is kept for the tick and the ticked border only).
import {computed} from 'vue';
import {ALREADY_SET_UP, ALWAYS_INCLUDED, NOT_PICKED} from '~/utils/setupGoals';

const props = defineProps({
  /** locked = Always included, done = Already set up, off = Not picked. */
  kind: {type: String, required: true, validator: (v) => ['locked', 'done', 'off'].includes(v)},
});
const TAGS = Object.freeze({
  locked: {label: ALWAYS_INCLUDED, icon: 'mdi-lock-outline'},
  done: {label: ALREADY_SET_UP, icon: 'mdi-check-circle-outline'},
  off: {label: NOT_PICKED, icon: null},
});
const tag = computed(() => TAGS[props.kind]);
</script>

<template>
  <span class="sgt" :class="'sgt--' + kind"><v-icon v-if="tag.icon" size="12" :icon="tag.icon"/>{{ tag.label }}</span>
</template>

<style scoped lang="scss">
/* One size for every label: 20px tall, 11.5px semibold, hairline border, full radius. */
.sgt {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  height: 20px;
  padding: 0 7px;
  border-radius: 999px;
  border: 1px solid rgb(var(--v-theme-borderLight));
  background: rgb(var(--v-theme-light));
  color: rgb(var(--v-theme-charcoal));
  font-size: 11.5px;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;

  /* Success-tinted, the words kept in ink-2 for contrast (success green on its tint is ~3:1); the icon carries the green. */
  &--done {
    border-color: transparent;
    background: rgb(var(--v-theme-successTint));

    .v-icon {
      color: rgb(var(--v-theme-success));
    }
  }
}
</style>
